import { z } from 'zod'

export const DocumentSequenceFormSchema = z.object({
  prefix: z
    .string({
      required_error: 'Zadejte předponu.',
    })
    .max(3, {
      message: 'Předpona může mít nejvýš 3 znaky.',
    }),
  year: z
    .union([
      z.literal('Y'),
      z.literal('y'),
      z.literal(''),
    ])
    .default('Y'),
  month: z
    .union([
      z.literal('m'),
      z.literal(''),
    ])
    .default(''),
  suffix: z
    .string({
      required_error: 'Zadejte příponu.',
    })
    .max(3, {
      message: 'Přípona může mít nejvýš 3 znaky.',
    }),
  exp: z
    .union([
      z.literal('100'),
      z.literal('1000'),
      z.literal('10000'),
      z.literal('100000'),
      z.literal('1000000'),
    ]),
  default: z.boolean(),
})
